export enum LocalStorageKeys {
  SELECTED_SITE = 'selected_site',
  ACCESS_TOKEN = 'access_token',
  USER_PROFILE = 'user_profile',
}
